import { toNumberString } from '@thesavingsgroup/utils/toNumberString';

import { MailCodeOfferDisplayValues } from '../types/MailCodeOfferDisplayValues';
import { MailCodeOfferValues } from '../types/MailCodeOfferValues';

export const toOfferDisplayValues = (
  offerValues: MailCodeOfferValues | undefined,
): MailCodeOfferDisplayValues => ({
  currentPayment: toNumberString(offerValues?.currentPayment),
  newPayment: toNumberString(offerValues?.newPayment),
  newRate: toNumberString(offerValues?.newRate),
  newTerm: toNumberString(offerValues?.newTerm),
  potentialSavings: toNumberString(offerValues?.potentialSavings),
  preApprovalAmount: toNumberString(offerValues?.preApprovalAmount),
});
